import React from 'react';
import { Helmet } from 'react-helmet';
import TermAndCondition from 'src/features/TradeDataLimitations';

const TradeDataLimitationsPage = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Trade Data Limitations</title>
      </Helmet>
      <TermAndCondition />
    </React.Fragment>
  );
};

export default TradeDataLimitationsPage;
